export const RAID_SEASON_STATUS_LABELS = Object.freeze({
  draft: '설정 중',
  active: '활성',
  closed: '종료',
});

export function raidSeasonStatusLabel(status) {
  const normalized = String(status || '').trim();
  return RAID_SEASON_STATUS_LABELS[normalized] || normalized || '설정 중';
}
